import React from "react";

import Modal from "../../../../components/elements/Modal";
import ManageEmails from "../ManageEmails";

function ManageEmailTemplateModal({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) {
  console.log(data, "data in modal");

  return (
    <Modal
      isOpen={open}
      setIsOpen={close}
      size="xl2"
      title={data?._id ? "Update Admin" : "Add Admin"}
    >
      <ManageEmails getResponse={getResponse} close={close} data={data} />
    </Modal>
  );
}

export default ManageEmailTemplateModal;
